import { render, staticRenderFns } from "./ConfigurePoint.vue?vue&type=template&id=049de61f&scoped=true&"
import script from "./ConfigurePoint.vue?vue&type=script&lang=js&"
export * from "./ConfigurePoint.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurePoint.vue?vue&type=style&index=0&id=049de61f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049de61f",
  null
  
)

export default component.exports